(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('billing', {
                parent: 'entity',
                url: '/billing',
                ncyBreadcrumb: {
                    label: 'Reports'
                },
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/billing/billing.html',
                        controller: 'BillingController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('billing2', {
                parent: 'entity',
                url: '/billing2',
                ncyBreadcrumb: {
                    label: 'Reports'
                },
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/billing/billing.html',
                        controller: 'Billing2Controller',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
